import AccountIcon from 'vue-material-design-icons/Account.vue';
import AccountMultipleIcon from 'vue-material-design-icons/AccountMultiple.vue';
import AccountMultipleOutlineIcon from 'vue-material-design-icons/AccountMultipleOutline.vue';
import ArrowLeftIcon from 'vue-material-design-icons/ArrowLeft.vue';
import BellIcon from 'vue-material-design-icons/Bell.vue';
import BellOutlineIcon from 'vue-material-design-icons/BellOutline.vue';
import BellOff from 'vue-material-design-icons/BellOff.vue';
import BellRing from 'vue-material-design-icons/BellRing.vue';
import ChevronDownIcon from 'vue-material-design-icons/ChevronDown.vue';
import CloseIcon from 'vue-material-design-icons/Close.vue';
import CommentOutlineIcon from 'vue-material-design-icons/CommentOutline.vue';
import DotsVerticalIcon from 'vue-material-design-icons/DotsVertical.vue';
import HomeIcon from 'vue-material-design-icons/Home.vue';
import HomeOutlineIcon from 'vue-material-design-icons/HomeOutline.vue';
import ImageIcon from 'vue-material-design-icons/Image.vue';
import MagnifyIcon from 'vue-material-design-icons/Magnify.vue';
import MenuIcon from 'vue-material-design-icons/Menu.vue';
import MessageOutlineIcon from 'vue-material-design-icons/MessageOutline.vue';
import PlusCircle from 'vue-material-design-icons/PlusCircle.vue';
import PlusIcon from 'vue-material-design-icons/Plus.vue';
import SendIcon from 'vue-material-design-icons/Send.vue';
import ShareIcon from 'vue-material-design-icons/Share.vue';
import StarIcon from 'vue-material-design-icons/Star.vue';
import StarOutlineIcon from 'vue-material-design-icons/StarOutline.vue';
import TagIcon from 'vue-material-design-icons/Tag.vue';
import TagOutlineIcon from 'vue-material-design-icons/TagOutline.vue';
import ThumbUpIcon from 'vue-material-design-icons/ThumbUp.vue';
import ThumbUpOutlineIcon from 'vue-material-design-icons/ThumbUpOutline.vue';

import Spinner from './Spinner.vue';

export default {
  Spinner,

  AccountIcon,
  AccountMultipleIcon,
  AccountMultipleOutlineIcon,
  ArrowLeftIcon,
  BellIcon,
  BellOutlineIcon,
  BellOff,
  BellRing,
  ChevronDownIcon,
  CloseIcon,
  CommentOutlineIcon,
  DotsVerticalIcon,
  HomeIcon,
  HomeOutlineIcon,
  ImageIcon,
  MagnifyIcon,
  MenuIcon,
  MessageOutlineIcon,
  PlusCircle,
  PlusIcon,
  SendIcon,
  ShareIcon,
  StarIcon,
  StarOutlineIcon,
  TagIcon,
  TagOutlineIcon,
  ThumbUpIcon,
  ThumbUpOutlineIcon,
};
